import React from 'react';
import { Drawer, Tag } from 'antd';
import { connect } from "react-redux";
import Modal from 'antd/lib/modal/Modal';
import { CloseOutlined } from '@ant-design/icons';
import { WidgetLoader } from 'datastake-daf/dist/components';
import { DrawerHeader, Header, ModalHeader, TabsHeader } from 'datastake-daf/dist/components';
import Table from './table';
import Merger from './merger';
import Updater from './update';
import { Styles } from './style';
import { TABS, tabs, useUpdate } from './hook';
import DeletionsTable from '../deletions/table';
import { actions } from "../../../store/reducers/admin";
import SubjectTableLayout from '../../../components/Layout/SubjectTableLayout';
import { CREATE_DRAWER_WIDTH } from '../../../helpers/form';

function Update({ admin: { globals }, getGlobals }) {
  const {
    getLabel,
    getExtra,
    loaded,
    loading,
    data,
    activeFilters,
    entity,
    selectOptions,
    tableColumns,
    setActiveFilters,
    entityData,
    edit,
    setEdit,
    setIsCreate,
    isCreate,
    admLevels,
    itemsToMerge,
    t,
    mergeIsVisible,
    mergerColumns,
    setMergeIsVisible,
    setMergerLoading,
    setItemsToMerge,
    fetchData,
    mergerLoading,
    removeItem,
    activeTab,
    setActiveTab,
    visibleTabs,
    onChangeDeleteFilters,
    noDeletion,
  } = useUpdate({ globals, getGlobals });

  return (
    <Styles className="semibold form-input-output">
      <SubjectTableLayout
        header={(
          <>
            <Header title={getLabel()} actionButtons={getExtra()} />
            <TabsHeader
              value={activeTab}
              onChange={(v) => setActiveTab(v)}
              tabs={tabs.map((tab) => ({
                disabled: tab.key === TABS.DELETED && noDeletion,
                value: tab.key,
                label: t(tab.label)
              }))}
            />
          </>
        )}
      >
        {(loading || !loaded) && <WidgetLoader />}
        {(loaded && visibleTabs[TABS.ACTIVE]) && (
          <div
            className='no-box-shadow p-0 daf-table-wrapper'
            style={{ display: activeTab === TABS.ACTIVE ? undefined : 'none' }}
          >
            <Table
              data={data}
              defaultActiveFilters={activeFilters}
              entity={entity}
              selectOptions={selectOptions}
              tableColumns={tableColumns}
              setActiveFilters={setActiveFilters}
            >
              <div className="flex-row tag-cont">
                {itemsToMerge.length ? itemsToMerge.map((item) => (
                  <Tag key={`tag-${item.id}`} className="flex-row">
                    <div className="flex-col">
                      <span className="mr-1">
                        {item.datastakeId || item.name}
                      </span>
                    </div>
                    <div className="flex-col">
                      <CloseOutlined onClick={() => removeItem(item)} />
                    </div>
                  </Tag>
                )) : null}
              </div>
            </Table>
          </div>
        )}

        {(loaded && visibleTabs[TABS.DELETED] && !noDeletion) && (
          <div
            className='no-box-shadow p-0 daf-table-wrapper'
            style={{ display: activeTab === TABS.DELETED ? undefined : 'none' }}
          >
            <DeletionsTable
              tabKey={entity}
              currentKey={entity}
              changeFilters={(v) => {
                onChangeDeleteFilters(v);
              }}
            />
          </div>
        )}
      </SubjectTableLayout>

      <Drawer
        destroyOnClose={true}
        title={<DrawerHeader title={t(entityData && entityData.name ? entityData.name : getLabel())} />}
        open={edit}
        maskClosable={false}
        onClose={() => {
          setEdit(false);
          setIsCreate(false);
        }}
        width={CREATE_DRAWER_WIDTH}
        key={entity}
        bodyStyle={{ padding: 0 }}
      >
        <Updater
          module="pme"
          view="admin"
          isCreate={isCreate}
          entity={entity}
          admLevels={admLevels}
          entityData={entityData}
          allData={(data || {}).result || []}
          onUpdate={() => {
            fetchData();
            setEdit(false);
            setIsCreate(false);
          }}
        />
      </Drawer>
      <Modal
        title={(
          <ModalHeader
            title={`${t('Merging')} ${itemsToMerge.length} ${t('subjects')}`}
          />
        )}
        open={mergeIsVisible}
        footer={null}
        width={1300}
        closable={false}
        destroyOnClose
      >
        <Merger
          fetchData={fetchData}
          itemsToMerge={itemsToMerge}
          setItemsToMerge={setItemsToMerge}
          mergerColumns={mergerColumns}
          module="pme"
          view="admin"
          entity={entity}
          setLoading={setMergerLoading}
          loading={mergerLoading}
          close={() => {
            if (!mergerLoading) {
              setMergeIsVisible(false);
            }
          }}
          t={t}
          clearItemsToMerge={() => setItemsToMerge([])}
          admLevels={admLevels}
        />
      </Modal>
    </Styles >
  );
}

const mstp = ({ admin }) => ({ admin });

export default connect(mstp, actions)(Update);
